import { Pipe, PipeTransform } from '@angular/core';
import { FirestoreDocument } from '../../../libs/shared/models/firestore-document';
import { Candidate } from '../../../libs/models/candidate/candidate.model';

@Pipe({
  name: 'candidate',
})
export class CandidatePipe implements PipeTransform {
  transform(candidate?: FirestoreDocument<Candidate> | null, type: 'fullName' = 'fullName'): string {
    if (!candidate) return 'undefined';
    switch (type) {
      case 'fullName':
        return this.getFullName(candidate);
    }
  }

  getFullName(candidate: FirestoreDocument<Candidate>) {
    const { firstName, lastName } = candidate.data;
    return `${firstName ?? ''} ${lastName ?? ''}`.trim();
  }
}
